import z from 'zod';

export const SectionIdSchema = z.enum(['root', 'fachportal', 'pta-family', 'academy', 'urology', 'nephrology']);

export type SectionId = z.infer<typeof SectionIdSchema>;
